import { Pipe, PipeTransform } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { WindowRefService } from '@app/core/services/helpers/window-ref.service';

@Pipe({
    name: 'safeUrl',
    standalone: false,
})
export class SafeUrlPipe implements PipeTransform {
    private window: Window;

    constructor(private windowRefService: WindowRefService) {
        this.window = this.windowRefService.window;
    }

    transform(url: string): SafeUrl {
        const trustedDomains = [this.window.origin, `blob:${this.window.origin}`, '/assets'];

        const regex = new RegExp(`^(?:${origin}|blob:${origin}|/assets)`);
        const isValidScheme = regex.test(url);
        const isTrustedDomain = trustedDomains.some((item) => url.startsWith(item));

        if (isValidScheme && isTrustedDomain) {
            return url;
        } else {
            throw new Error('Unstrusted resource.');
        }
    }
}
